export const DropIndicator = () => {
  return (
    <div className="w-full h-11 mb-2 bg-[var(--primary-50)] border-[1.5px] border-dashed border-[var(--primary-300)] rounded-[10px]" />
  );
};
